var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC72D"
    },
    d: "M256,121.598c-33.525,0-60.799-27.275-60.799-60.799S222.475,0,256,0s60.799,27.275,60.799,60.799 S289.525,121.598,256,121.598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M256,0v121.598c33.525,0,60.799-27.275,60.799-60.799S289.525,0,256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF423D"
    },
    d: "M322.685,92.098c-37.934-11.276-95.744-11.185-133.37,0c-79.81,23.739-138.178,97.78-138.178,185.182 v104.923c0,10.34,8.379,18.732,18.732,18.732h372.261c10.352,0,18.732-8.392,18.732-18.732V277.279 C460.862,189.877,402.494,115.837,322.685,92.098z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F32E28"
    },
    d: "M322.685,92.098c-18.937-5.63-42.826-8.426-66.685-8.423v317.259h186.131 c10.352,0,18.732-8.392,18.732-18.732V277.279C460.862,189.877,402.494,115.837,322.685,92.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F32E28"
    },
    d: "M336.771,136.404v264.529h-37.463V136.404c0-52.815-86.615-52.645-86.615,0v264.529h-37.463V136.404 c0-16.484,5.22-31.781,14.086-44.307c36.931-10.979,94.822-11.46,133.37,0C331.551,104.623,336.771,119.92,336.771,136.404z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0231B"
    },
    d: "M322.685,92.098c-19.111-5.681-42.977-8.424-66.685-8.412v13.171 c21.654-0.021,43.308,13.14,43.308,39.548v264.529h37.463V136.404C336.771,119.92,331.551,104.623,322.685,92.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC72D"
    },
    d: "M481.924,512H30.076c-10.345,0-18.732-8.387-18.732-18.732V382.197 c0-10.345,8.387-18.732,18.732-18.732h451.849c10.345,0,18.732,8.387,18.732,18.732v111.072 C500.656,503.613,492.269,512,481.924,512z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M481.924,363.465H256V512h225.924c10.345,0,18.732-8.387,18.732-18.732V382.197 C500.656,371.852,492.269,363.465,481.924,363.465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M299.96,456.464H212.04c-10.345,0-18.732-8.387-18.732-18.732c0-10.345,8.387-18.732,18.732-18.732 h87.919c10.345,0,18.732,8.387,18.732,18.732C318.691,448.077,310.304,456.464,299.96,456.464z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9B00"
    },
    d: "M299.96,419.001H256v37.463h43.96c10.345,0,18.732-8.387,18.732-18.732 C318.691,427.388,310.304,419.001,299.96,419.001z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.3ee63347abcc7ccdc60e78bd5151a5e0.svg";
export { ForwardRef as ReactComponent };